/* eslint-disable jsx-a11y/anchor-is-valid */
// import clsx from 'clsx'
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PaymentHistory} from '../../core/_models'
// import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'

type Props = {
  PaymentHistory: PaymentHistory
}

const PaymentHistoryStatus: FC<Props> = ({PaymentHistory}) => {
  const intl = useIntl()
  return (
    <div className='d-flex text-center justify-content-center'>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {PaymentHistory.paid === true && (
            <div className='badge  badge-success  fw-bolder fs-9'>
              {intl.formatMessage({id: 'CONTRACTS.PAID'})}
            </div>
          )}
          {PaymentHistory.paid === false && (
            <div className='badge badge-warning  fw-bolder fs-9'>
              {intl.formatMessage({id: 'CONTRACTS.OPENED'})}
            </div>
          )}
        </a>
      </div>
    </div>
  )
}

export {PaymentHistoryStatus}
